// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Components
import {
  LineChart,
  LineChartType,
} from '../../../../../../layout/elements/LineChart';

// View
import { MotorCurrentProps } from './MotorCurrent.types';
import { ChartMode } from '../Trendings.types';

function MotorCurrent({
  className,
  chartMode,
  testId,
  trendingMotorCurrentData,
}: MotorCurrentProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();

  // Generate dynamic ID based on chart mode
  const chartId: string = `motor-current-${chartMode}`;

  return (
    <LineChart
      activeBullet={chartMode === ChartMode.live || chartMode === ChartMode.liveAggregate}
      className={className}
      data={trendingMotorCurrentData}
      id={chartId}
      series={[
        {
          name: t('common.cloudConnection'),
          field: 'edgeStatus',
          type: LineChartType.fill,
          date: 'timestamp',
          opposite: true,
        },
        {
          name: t('view.crusher.trendings.motorCurrent.title'),
          field: 'crusherMotorAmps',
          type: LineChartType.line,
          date: 'timestamp',
          color: 'orange',
          unit: 'A',
          bullet: true,
          decimals: 2,
          minScale: 0,
          maxScale: 750,
        },
      ]}
      testId={testId}
    />
  );
}

export { MotorCurrent };
